import { ref } from 'vue';
import globalConstant from '@/assets/js/globalConstant.js'
/**
 * 调用浏览器 localStorage 保存缓存信息
 */
export function setLocalStorage(key, value) {
  let curTime = new Date().getTime() //毫秒级别
  localStorage.setItem(key, JSON.stringify({ data: value, time: curTime }))
}

/**
 * 判断是否为移动端
 */
export function isMobile() {
  return ('ontouchstart' in document.documentElement) || (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
}

/**
 * 根据key 调用浏览器 localStorage 获取缓存信息
 */
export function getLocalStorage(key, exp) {
  let data = localStorage.getItem(key)
  if (data) {
    try {
      let dataObj = JSON.parse(data)
      if (exp) {
        if (dataObj.time && new Date().getTime() - dataObj.time > exp) {
          localStorage.removeItem(key)
          return null
        } else {
          return dataObj.data
        }
      } else {
        return dataObj.data
      }
    } catch (err) {
      localStorage.removeItem(key)
      return null
    }
  } else {
    return null
  }
}

/**
 * 清除浏览器 localStorage 中的缓存信息
 */
export function clearLocalStorage() {
  localStorage.clear()
}

/**
 * 根据key 调用浏览器 localStorage 移除缓存信息
 */
export function removeLocalStorage(key) {
  localStorage.removeItem(key)
}
/**
 * 判断字符是否为空串
 */
export function isNotEmptyString(string) {
  return typeof string === 'string' && string.trim() !== '';
}

/**
 * 判断字符是否在某个字符串中
 */
export function hasCharacter(str, char) {
  if (!str || !char) {
    return false;
  }
  return str.indexOf(char) !== -1;
}

/**
 * 过滤数组中指定属性值的对象
 * @param {Array} array - 需要过滤的原始数组
 * @param {*} value - 用于匹配对象属性值的筛选条件
 * @returns {string} 返回包含所有匹配对象的新数组
 */
export function filterArray(array, value) {
  if (isNotEmptyString(value)) {
    const obj = array.find(item => item.value === value);
    return obj.text;
  }
  return '';
}